import React, { ElementType, useEffect, useState } from 'react';
import { EventList as EventListClass } from '../../ReportsClasses';
import { Button, Groupper, Header, Image, Placeholder, Toast } from 'react-frontier';
import { CDN_URL, PLACEHOLDER_IMG } from '../../ReportsConfig';
import { Link } from 'react-router-dom';
import { useUser } from '../../ReportHooks';
import { useTranslation } from 'react-i18next';
import API from '../../ReportsAPI';
import moment from 'moment';

type EventItemProps<E extends ElementType> = React.ComponentPropsWithoutRef<E> & {
	as?: E,
	event?: EventListClass,
	placeholder?: boolean,
}

var EventItem = <E extends ElementType>(props: EventItemProps<E>)=>{
	var { t } = useTranslation();
	var {
		event,
		placeholder,
		...restProps
	} = props;

	if(props.placeholder){
		return <div className="ar event-item placeholder">
			<div className="image"></div>
			<div className="info">
				<Placeholder width={220} height={24} style={{ display: 'block', marginBottom: 2 }} />
				<Placeholder style={{ display: 'block', marginBottom: 2 }} />
				<Placeholder style={{ display: 'block', marginBottom: 2 }} />
			</div>
		</div>
	}
	if(!props.event) return null;
	const Component = props.as || 'div';

	return <Component className="ar event-item" {...restProps}>
		<Image src={`${CDN_URL}/events/${props.event.event_id}/200.webp`} alt={props.event.event_name} className="image" fallback={PLACEHOLDER_IMG} />
		<div className="info">
			<div className="name">{props.event.event_name}</div>
			<div className="meta">
				{props.event.tickets ? (
					// `${addCommas(props.event.tickets, false)} boleto${props.event.tickets===1 ? '' : 's'}`
					t('events.tickets_sold', { count: props.event.tickets })
				) : (
					moment.unix(props.event.date).format('DD/MMM/YY HH:mm')
				)}
			</div>
			<div className="meta">{props.event.city}{props.event.state && props.event.state.length>0 ? ', ' : ''}{props.event.state && props.event.state.length>0 ? props.event.state : ''}</div>
		</div>
	</Component>
}

var EventList = ()=>{
	var { is_admin } = useUser();
	var { t } = useTranslation();
	var [events, setEvents] = useState<EventListClass[]>(null);
	var [searching, setSearching] = useState<boolean>(false);
	var [searchQuery, setSearchQuery] = useState<string>('');
	var [searchEvents, setSearchEvents] = useState<EventListClass[]>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		setLoadError(null);
		API.getEvents(0, 20).then(res=>{
			if(res.error) return setLoadError(res.message);
			setEvents(res.data);
		}).catch(err=>{
			setLoadError(t('common.error_code', { type: 'cargando los eventos', code: 'LCL-1' }));
		})
	}, []);

	var searchEvent = ()=>{
		if(!searchQuery || searchQuery.length<3){
			return Toast.error(t('events.form.search', { amount: 3 }));
		}
		setSearchEvents(null);
		setSearching(true);
		API.searchEvents(searchQuery).then(res=>{
			if(res.error) return Toast.error(res.message);
			setSearchEvents(res.data);
		}).catch(err=>{
			setLoadError(t('common.error_code', { type: 'buscando eventos', code: 'LCL-1' }));
		})
	}

	var onSearchChange = (val: string)=>{
		if(val.length<3 && searching){
			setSearching(false);
		}
		setSearchQuery(val);
	}

	return <div className="ar event-list-screen">
		<Groupper title={t('events.title')} titleSize='big' width={600} titleCentered>
			{is_admin && !loadError && (
				<Groupper.DividerInput value={searchQuery} onChange={onSearchChange} submitOnEnter top placeholder={t('events.search')} onSubmit={searchEvent} button={(
					<Button text={t('common.search')} onClick={searchEvent} disabled={searching} />
				)} />
			)}
			{loadError ? (
				<Header iconName='face-frown-open' text={t('common.error')} subtext={loadError} style={{ margin: '100px 0' }} />
			) : searching ? (
				searchEvents ? (
					searchEvents.map(a=>(
						<EventItem as={Link} event={a} to={`/miseventos/${a.event_id}`} key={`EVLSTSH-${a.event_id}`} />
					))
				) : (
					<Header loading text={t('events.searching')} />
				)
			) : events ? (
				events.length==0 ? (
					<Header text={t('events.no_events')} subtext={t('events.no_events_detail')} iconName='face-frown-open' />
				) : events.map(a=>(
					<EventItem as={Link} event={a} to={`/miseventos/${a.event_id}`} key={`EVLST-${a.event_id}`} />
				))
			) : new Array(5).fill('L').map((a, i)=>(
				<EventItem event={null} placeholder key={`EVLSTPH-${i}`} />
			))}
		</Groupper>
	</div>
}

export default EventList;